import { useUserStore } from '~/store/userStore'
import { useTocStore } from '~/store/tocStore'
import { UserAuthGroup } from '~/enums'
import routerJson from '@/assets/data/router.json'
import { getDesignTocRoute, allReplaceComponent } from '~/app/router.options'

export const useSidebarRoutes = () => {
  const userStore = useUserStore()
  const tocStore = useTocStore()

  const getSidebarRoutes = computed(() => {
    const userAuthGroup = userStore.loginUserInfo?.authGroupSeq
    if (!userAuthGroup) return []

    // router.options.ts의 getDesignTocRoute 함수를 사용하여 동적으로 생성된 라우트 가져오기
    const allRoutes = getDesignTocRoute(userAuthGroup);
    console.log('All routes from getDesignTocRoute:', allRoutes);
    
    const dynamicRoutes = allRoutes.children.filter((route: any) => route.name !== 'design-toc-user')
    
    console.log('Dynamic Routes from getDesignTocRoute:', dynamicRoutes);
    
    // sidebar가 false가 아닌 라우트만 필터링
    const filteredRoutes = dynamicRoutes.filter((route: any) => route.meta?.sidebar !== false)
    
    console.log('Filtered Sidebar Routes:', filteredRoutes);
    
    return filteredRoutes
  })

  return {
    getSidebarRoutes
  }
}

